import validator from "validator";

const emailValidator = (str) => {
  return validator.isEmail(str);
};

export default emailValidator;
